import { render, staticRenderFns } from "./GlobalMessage.vue?vue&type=template&id=1ca82972&scoped=true&"
import script from "./GlobalMessage.vue?vue&type=script&lang=js&"
export * from "./GlobalMessage.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMessage.vue?vue&type=style&index=0&id=1ca82972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca82972",
  null
  
)

export default component.exports